import React from 'react';
import RtRecordingTime from './rt-recording-time';
import { t } from '../multi-language/multi-lang.service';
export default function RtDetailes(_a) {
    var isAf = _a.isAf, isStopped = _a.isStopped, record = _a.record;
    var getAfStatusText = function () {
        // let text = 'not_detected'
        // if (isAf) text = 'detected'
        var text;
        if (isStopped)
            text = 'stopped';
        return text && t("af_status.".concat(text));
    };
    return (React.createElement("div", { className: 'info-bottom-section' },
        React.createElement("span", { className: " size-2 status-af ".concat(isAf || isStopped ? 'red-team' : 'green-team') }, getAfStatusText()),
        React.createElement(RtRecordingTime, { record: record })));
}
//# sourceMappingURL=rt-details.js.map